function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-v-3ee2a61c": "",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  "data-v-3ee2a61c": "",
  transform: "translate(0.000000, -1122.000000)",
  fill: "rgba(0,0,0,0.5)"
}, React.createElement("path", {
  "data-v-3ee2a61c": "",
  d: "M0,1122 L375,1122 L375,1612 L0,1612 L0,1122 Z M190.098733,1254.81082 C226.383272,1254.81082 229.229118,1254.81082 241.323965,1206 L233.497888,1206 C230.296311,1215.54196 227.450465,1217.00996 220.335849,1217.00996 C203.972233,1217.37696 187.608617,1217.74396 168.399155,1217.74396 C147.055308,1217.74396 143.853731,1220.67994 143.14227,1236.82788 L138.51777,1324.54055 C146.343847,1320.87057 154.881386,1319.03557 163.418924,1319.03557 C197.92481,1319.03557 203.260772,1350.23045 203.260772,1379.22334 C203.260772,1410.05123 198.280541,1438.67712 168.754886,1438.67712 C157.371501,1438.67712 147.411039,1433.90614 147.411039,1427.66716 C147.411039,1419.22619 166.26477,1422.16218 166.26477,1400.50926 C166.26477,1392.0683 159.861616,1381.05834 146.699578,1381.05834 C132.826077,1381.05834 125,1390.9673 125,1404.91325 C125,1432.43814 149.189693,1447.48509 173.735117,1447.48509 C224.604618,1447.48509 249.150042,1413.35422 249.150042,1376.28736 C249.150042,1337.7525 218.557195,1308.75961 181.205463,1308.75961 C169.466347,1308.75961 158.438693,1310.22761 147.055308,1314.26459 L150.968347,1254.81082 L190.098733,1254.81082 Z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    "data-v-3ee2a61c": "",
    "data-v-59251244": "",
    width: "375px",
    height: "490px",
    viewBox: "0 0 375 490",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/mask5.248c1852.svg";
export { SvgComponent as ReactComponent };